const GENDER_AGE_TOKEN_PATTERNS = [
  /^(?:G|B)U(?:[4-9]|1\d|2[0-3])$/,
  /^U(?:[4-9]|1\d|2[0-3])(?:G|B)$/,
  /^(?:G|B)(?:[4-9]|1\d|2[0-3])$/,
  /^(?:[4-9]|1\d|2[0-3])U(?:G|B)$/,
];

const AGE_TOKEN_PATTERNS = [
  /^U(?:[4-9]|1\d|2[0-3])$/,
  /^(?:[4-9]|1\d|2[0-3])U$/,
];

const BIRTH_YEAR_PATTERNS = [
  /^(?:19|20)\d{2}$/,
  /^(?:G|B)(?:19|20)\d{2}$/,
  /^(?:19|20)\d{2}(?:G|B)$/,
];

const LEVEL_TOKENS = new Set(["AAA", "AA", "JV"]);

/** Return only a name token that is safe to present as an age-group label. */
export function teamAgeGroup(name: string): string | null {
  const tokens = name.toUpperCase().match(/[A-Z0-9]+/g) ?? [];
  return (
    tokens.find((token) =>
      GENDER_AGE_TOKEN_PATTERNS.some((pattern) => pattern.test(token)),
    ) ??
    tokens.find((token) =>
      AGE_TOKEN_PATTERNS.some((pattern) => pattern.test(token)),
    ) ??
    null
  );
}

/** Produce the compact fallback mark shared by admin and public team cards. */
export function teamBadgeLabel(name: string): string {
  const tokens = name.toUpperCase().match(/[A-Z0-9]+/g) ?? [];
  const age = teamAgeGroup(name);
  if (age) return age;

  const birthYear = tokens.find((token) =>
    BIRTH_YEAR_PATTERNS.some((pattern) => pattern.test(token)),
  );
  if (birthYear) return birthYear;

  const level = tokens.find((token) => LEVEL_TOKENS.has(token));
  if (level) return level;

  const initials = tokens
    .filter((token) => !/^\d+$/.test(token))
    .slice(0, 2)
    .map((token) => token[0])
    .join("");
  return initials || tokens[0]?.slice(0, 4) || "–";
}
